import * as React from "react"
const Corner = (props) => (
	<svg width="22" height="22" xmlns="http://www.w3.org/2000/svg" {...props}>
	<path d="M 2 20 L 2 16 Q 2 2 16 2 L 20 2" stroke="#0086C9" fill="none" strokeWidth="2"   strokeLinecap="round"   />
</svg>
)
export default Corner
